module.exports = __webpack_public_path__ + "static/media/pa.7b505d3a.png";